define('views/blocks/paymentModeProviders/OgoneDirectIFrameView',['underscore', 'app',
    'ApiRequest',
    'views/blocks/paymentModeProviders/OgoneIFrameView',
    'PaymentModeSelectionBoardView',
    'template!blocks/paymentmodes/ogone-direct-iframe',
],function(_, app, ApiRequest,
           OgoneIFrameView,
           PaymentModeSelectionBoardView,
           ogoneDirectIFrameTemplate
){

    return OgoneIFrameView.extend({
        name:'ogone-direct-iframe',
        afterRender:function(){
            var view = this;
            view.displayAddCardForm()
        },
        renderInner:function(){
            return ogoneDirectIFrameTemplate();
        },
        displayAddCardForm:function(){
            var view = this,
                checkoutModel = view.checkoutModel,
                details$El = view.$('.ogone-direct__iframe-wrapper'),
                form = view.$('.ogone-direct-form'),
                paymentMode = view.paymentMode,
                attach_to_cart = true;
            var id_store;
            // CVC ou 3DS
            var id_card = paymentMode.getOption('id_card', false, true);
            var hasCard = !!id_card;
            var iframeOptions = paymentMode.getOption('iframeOptions');
            var checkboxStorePermanently = view.$('#tokenization-storage');
            console.log('options',id_card,iframeOptions,paymentMode.getOptions());
            //
            if(checkoutModel){
                id_store = checkoutModel.getCart().getStore().id;
            }else{
                id_store = 'auto';
                attach_to_cart = false;
            }
            var requestParams = {
                // todo : j'ai utilisé id_payment_method = 9 valeur historique
                id_payment_method: 9,
                id_payment_mode: paymentMode.id,
                // TODO utiliser la valeur du panier, en dur pour le test
                attach_to_cart: attach_to_cart,
                id_store: id_store,
            };
            function CreateCard(hostedTokenizationId,productId, storePermanently){
                ApiRequest('ToolsPaymentMethod', {
                    id_payment_mode: paymentMode.id,
                    hostedTokenizationId:hostedTokenizationId,
                    paymentProductId:productId,
                    storepermently:storePermanently?"Y":"N",
                    id_store:id_store,
                },{method: 'createCard'}).done(function (data) {
                    if(data.status === "success"){
                        var card = data.card;
                        app.getCustomer().addPaymentCard(card);
                        paymentMode.setOption('id_card',card.id_card,true);
                        //paymentMode.de('iframeOptions');
                        paymentMode.setOption('cvc','',true);
                        view.close();
                    }else{
                        app.blockError(details$El);
                    }
                })
                .fail(function(){
                    app.blockError(details$El);
                });
            }

            function LoadTokenization(iframeUrl){
                var worldlineTokenizerUrl = app.c('_WORDLINE_TOKENIZER_URL_','https://payment.preprod.direct.worldline-solutions.com/hostedtokenization/js/client/tokenizer.min.js');
                console.log("LoadTokenization",iframeUrl);
                function onWorldlineTokenizerReady(HostedTokenizer){
                    console.info("onWorldlineTokenizerReady")
                    var btn = details$El.find('button');
                    var hostedTokenizationUrl = iframeUrl;
                    var paymentProductId = null;
                    function paymentProductUpdatedCallback(success){
                        try{
                            paymentProductId = success.selectedPaymentProduct.id || null;
                            console.log("paymentProductUpdatedCallback",paymentProductId);
                        }catch (err){
                            paymentProductId = null;
                        }
                    }

                    if(hasCard) {
                        var tokenizer = new Tokenizer(hostedTokenizationUrl, 'ogone-direct-hosted-tokenization2', {
                            hideTokenFields:true,
                            paymentProductUpdatedCallback:paymentProductUpdatedCallback
                        });
                    }else {
                        var tokenizer = new Tokenizer(hostedTokenizationUrl, 'ogone-direct-hosted-tokenization', {
                            hideCardholderName: false,
                            paymentProductUpdatedCallback:paymentProductUpdatedCallback
                        });
                    }

                    function submitForm(){ //
                        console.log("submitForm");
                        btn.toggleClass("loading", true);
                        btn.attr("disabled", true);
                        var storePermanently = !!checkboxStorePermanently.is(':checked');
                        var params = hasCard ? {} : {
                            storePermanently:storePermanently,
                        };
                        tokenizer.submitTokenization(params).then(function(result) {
                            if (result.success) {
                                // Proceed
                                console.log("Tokenization success",result);
                                var hostedTokenizationId = result.hostedTokenizationId || null;
                                CreateCard(hostedTokenizationId,paymentProductId, storePermanently);
                            } else {
                                console.error("error",result);
                                app.error("Ogone Direct Tokenization error",result);
                                app.blockError(details$El);
                            }
                        });
                    }

                    tokenizer.initialize().then(function(){
                        // Do work after initialization, if any
                        btn.toggleClass("hidden", false);
                        details$El.find('.loader').toggleClass("hidden",true);
                        form.toggleClass('hidden',false);
                        btn.on("click", submitForm);
                    }).catch(function(reason) {
                        // Handle iFrame load error
                        console.error("error",reason);
                        app.error(reason);
                        app.blockError(details$El);
                    })
                    // details$El.html(data.iframe+"<button type='button' class='btn btn-classic lg btn-primary w100'>"+app.t("Valider","UI")+"</button>");
                }
                require([worldlineTokenizerUrl],onWorldlineTokenizerReady);
            }


            if(id_card && iframeOptions){
                // demande de CVC ou 3DS
                view.$('.check-group').remove();
                LoadTokenization(iframeOptions.url)
            }else{
                // nouvelle carte
                ApiRequest('ToolsPaymentMethod',requestParams,{method: 'getCbEncrypt'})
                    .done(function (data) {
                        LoadTokenization(data.url);
                    })
                    .fail(function(){
                        app.blockError(details$El);
                        app.error('ToolsPaymentModeError',requestParams);
                    });
            }


        },
    });
});
